module.exports = __webpack_public_path__ + "static/media/sawatzky_logo_white.c14c9562.png";